const baseFitmentFields = ['Year', 'Make', 'Model'];
const extraFitmentFields = ['Engine', 'Submodel', 'Position', 'Notes'];

const pageSize = 30;
const mobileScreenWidth = 800;
const brandPageSelector = '[data-content-region="brand_below_header"]';
const categoryPageSelector = '[data-content-region="category_below_header"]';
const showVehicleWidget =
  window.location.pathname === '/' ||
  window.location.pathname === '/search/' ||
  window.document.querySelector(`.home, #cm_results, ${categoryPageSelector}, ${brandPageSelector}`);

function setHeight(height) {
  document.body.style.paddingTop = `${height}px`;
  document.querySelector('.header').style.height = `${height}px`;
}

function InitFunc() {
  window.addEventListener('load', function () {
    let adminBar = 0;
    const headerLogo = document.querySelector('.header-logo--wrap').offsetHeight;
    const navPages = document.querySelector('.navPages-container').offsetHeight;
    if (document.body.classList.contains('hasAdminBar') && document.body.classList.contains('cm_desktop')) {
      adminBar = document.querySelector('.adminBar').offsetHeight;
    }
    if (document.querySelector('.adminBar')) {
      if (document.body.classList.contains('cm_desktop')) {
        adminBar = document.querySelector('.adminBar').offsetHeight;
      } else {
        document.body.className = document.body.className.replace('hasAdminBar', '');
      }
    }
    const height = adminBar + headerLogo + navPages;
    setHeight(height);

    document.body.onscroll = () => {
      const vehicleWidget = document.querySelector('.cm_vehicle-widget_container__header');
      if (vehicleWidget) {
        vehicleWidget.style.display = document.querySelector('.header').classList.contains('slim')
          ? 'none'
          : 'block';
      }
    };
  });
}

export default {
  platform: 'bigcommerce',
  InitFunc,
  sortFields: ['relevance', 'price', 'price:desc', 'name', 'date_created:desc'],
  defaultView: 'grid',
  SearchRequestDefaults: {
    pageSize,
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
  },
  product: {
    noImageSrc:
      'https://cdn11.bigcommerce.com/s-r0htteq447/stencil/7ceb4690-ea6b-0138-9a50-0242ac110008/e/19466af0-2217-0139-9e85-0242ac11000a/img/ProductDefault.gif',
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '.page-content',
      template: 'SearchPage',
      visibleIf: { selector: '#cm_results' },
    },
    {
      name: 'SearchPageCategory',
      type: 'SearchPage',
      location: '.grid-bg .container',
      template: 'SearchPage',
      visibleIf: { selector: categoryPageSelector },
    },
    {
      name: 'SearchPageBrand',
      type: 'SearchPage',
      location: '.page',
      visibleIf: { selector: brandPageSelector },
      template: 'SearchPage',
    },
    {
      name: 'FitmentTable',
      location: { insertAfter: '#accordion--description div' },
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'SearchBox',
      location: '.quickSearchWrap',
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        insertAfter: '.header',
        class: 'cm_search-box-root__mobile-container',
      },
      template: 'searchBox/dialogButtonAdaptable',
    },
    {
      name: 'VehicleSpecs',
      type: 'VehicleWidget',
      fields: extraFitmentFields,
    },
    {
      name: 'HeaderVehicleWidget_base',
      type: 'VehicleWidget',
      location: { insertAfter: '.navPages', class: 'cm_vehicle-widget_container__header' },
      template: 'fitmentSearch/homeVehicleWidget',
      visibleIf: () => window.innerWidth > mobileScreenWidth && showVehicleWidget,
      fields: baseFitmentFields,
      columnBreakpoint: mobileScreenWidth,
    },
    {
      name: 'HeaderVehicleWidget_mobile',
      type: 'VehicleWidget',
      location: { insertBefore: '.body', class: 'cm_vehicle-widget_container__mobile' },
      template: 'fitmentSearch/collapsibleVehicleWidget',
      visibleIf: () => window.innerWidth <= mobileScreenWidth && showVehicleWidget,
      columnBreakpoint: mobileScreenWidth,
    },
    {
      name: 'SearchHeader',
      sortSelectClass: 'form-select form-select--small',
    },
    {
      name: 'VerifyFitment',
      location: { insertAfter: '.productView-product' },
      template: 'fitmentSearch/verifyFitment',
      columnBreakpoint: 1000,
    },
    {
      name: 'SearchResult',
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
    },
    {
      name: 'FacetPanel',
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
  ],
};
